<template>

	<ul class="nav" v-if="!$mq.mobile">
		<anchor-link el="li" to="top" :class="['item', {active: activeAnchor === 'top'}]">
			<div class="tip">
				<div class="tip-inner">Top</div>
			</div>
		</anchor-link>
		<anchor-link el="li" :to="anchor" v-for="(component, anchor) in anchors" :key="anchor" :class="['item', {active: activeAnchor === anchor}]">
			<div class="tip">
				<div class="tip-inner">{{ component.title }}</div>
			</div>
		</anchor-link>
	</ul>

</template>

<script>

	import AnchorLink from "./AnchorLink"

	export default {
		name: "dotNav",
		props: {
			anchors: Object,
			activeAnchor: String
		},
		components: {
			AnchorLink
		}
	}

</script>

<style lang="scss" scoped>
	@import "list-style-reset";
	@import "responsive-font";
	@import "~npm/bourbon/app/assets/stylesheets/_bourbon";

	.nav {
		@include list-style-reset;
		position:fixed; top:50%; left:10px; transform:translateY(-50%); z-index:99; display:flex; flex-direction:column;
		.item {
			display:flex; align-items:center; cursor:pointer; position:relative; padding:.25em 0;
			&::before {
				display:block; width:.6rem; height:.6rem; content:''; border-radius:50%; background: #fff; border: .1rem solid #FDB913
			}
		}
		.active {
			&::before {
				background:#FDB913;
			}
		}
		.tip {
			display:flex; align-items:center; position:absolute; left:calc(100% + .25em); opacity:0; transition:opacity .3s ease; pointer-events:none; font-size:70%;
			&::before {
				@include triangle(.75em, #3d3d3d, left);
				content:'';
			}
		}
		.tip-inner {
			background:#3d3d3d; color:#fff; padding:.5em .75em; border-radius:5px; line-height:1; white-space:nowrap;
		}
		.item:hover .tip {
			opacity:1;
		}
	}


</style>



// WEBPACK FOOTER //
// src/components/AnchorNav/DotNav.vue